export interface ActivityManagerConfig {
    events: string[]; // list of events that are considered as user activity
    inactivityThreshold: number; // no.of milliseconds after which the user is considered inactive when there is no activity
    element: Element | Document; // The boolean to indicating that the event is dispatched to listner before being dispatched to EventTarget
    passive: boolean; // The boolean to indicate that event listner never calls preventDefault
    capture: boolean; // The element to which event listeners are added
}

const DEFAULT_EVENTS = ['mousedown', 'keydown', 'scroll', 'mousewheel'];
const DEFAULT_ELEMENT: Element | Document = document;
const DEFAULT_CONFIG: ActivityManagerConfig = {
    events: DEFAULT_EVENTS,
    inactivityThreshold: 1 * 60 * 1000, // 1 min
    element: DEFAULT_ELEMENT,
    passive: true,
    capture: true,
};

let lastActivityTime: number;
let config: ActivityManagerConfig | null = null;

export function initialize(acitivtyManagerconfig: ActivityManagerConfig) {
    config = acitivtyManagerconfig;
    lastActivityTime = Date.now();
    addEventListeners(config.element, config.events, handleEvent, config.capture, config.passive);
}

export function addEventListeners(
    element: Element | Document,
    events: string[],
    eventHandler: (e: Event) => void,
    capture: boolean,
    passive: boolean
) {
    if (element != null && events != null) {
        events.forEach(eventname =>
            element.addEventListener(eventname, eventHandler, {
                capture: capture,
                passive: passive,
            })
        );
    }
}

export function handleEvent(event: Event) {
    lastActivityTime = Date.now();
}

export function isUserIdle(): boolean {
    if (config === null) {
        initializeActivityManager();
    }

    // `config` is intialized by above call if it was previously null
    if (Date.now() - lastActivityTime > config!.inactivityThreshold) {
        return true;
    }
    return false;
}

export function getLastActivityTime() {
    return lastActivityTime;
}

export function initializeActivityManager() {
    if (config === null) {
        initialize(DEFAULT_CONFIG);
    }
}
